import React, { useState } from 'react';

import NumberHelper from '../../../util/number_helper';

import AiSparklesIcon from 'icons/ai-sparkles.svg';

import InfoPopover from './InfoPopover';

const HeadlineBar = ({ mentionCount, onInfoClicked, onLinkClicked, onCloseClicked, loading }) => {
  const [popoverIsOpen, setPopoverIsOpen] = useState(false);
  const showCount = !loading && mentionCount > 0;

  const openClicked = () => {
    onInfoClicked();
    setPopoverIsOpen(true);
  };

  const closeClicked = () => {
    onCloseClicked();
    setPopoverIsOpen(false);
  };

  return (
    <>
      <div className="ai-sparkles">
        <AiSparklesIcon />
      </div>
      {/* Always render the count's span, even while it's empty. Page translators replace the heading's text nodes,
          so React can't insert a new element before them once the count loads. */}
      <h2>
        Sentiment Analysis for{' '}
        <span className="mention-count" data-testid="mention-count">
          {showCount && NumberHelper.formatStatistic(mentionCount)}
        </span>{' '}
        Bluesky and X {mentionCount === 1 ? 'mention' : 'mentions'}
      </h2>
      <button className="help" onClick={openClicked} popovertarget="infoPopover" popovertargetaction="show">
        <span aria-hidden>&#xe913;</span>
        <span className="visually-hidden">Learn more about Sentiment Analysis</span>
      </button>
      <InfoPopover isOpen={popoverIsOpen} onLinkClicked={onLinkClicked} onCloseClicked={closeClicked} />
    </>
  );
};

export default HeadlineBar;
